
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import IndexDocumentPer from './IndexPendingDocument';

import { useLocation } from "react-router-dom";
import { useEffect } from 'react';



export default function MainDocumentPersonal() {
  const ScrollToTop: React.FC = () => {
    const location = useLocation();

    useEffect(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth", // This makes the scroll action smooth
      });
    }, [location]); // This effect runs whenever the route changes

    return null; // This component doesn't render anything
  };

  return (

    <Box
      sx={{
        // minHeight: "150vh",
        borderRadius: "20px",
        // marginTop: -10, // ปรับระยะห่างด้านบนตามต้องการ
        padding: '30px 5px 5px 5px', // เพิ่ม padding เพื่อให้เนื้อหาภายในมีพื้นที่มากขึ้น
        backgroundColor: "#f5f5f5", // ตัวอย่างสีพื้นหลัง
      }}
    >
      <ScrollToTop />
      <IndexDocumentPer />
    </Box>

  );
}